<template lang="pug">
.require
  span.require-label 必須
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

/**
 * ### 必須入力のラベル
 */
@Component
export default class RequireInput extends Vue {}
</script>

<style lang="scss" scopeed>
@import "../../styles/mobile/_colors.scss";
.require {
  min-width: 2.4rem;
  width: 2.4rem;

  .require-label {
    color: $font-strong;
    font-size: 0.8rem;
    border: 1px solid $font-strong;
    padding: 0 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 3px 0 4px 0;
  }
}
</style>
